<script setup lang="ts">
import { computed } from 'vue'

interface Props {
  data: object | string | number
  cellConfig: Object
  tableConfig?: Object
}

const props = defineProps<Props>()

type TagItem = {
  label?: string
  type?: string
  class?: string
  style?: string | Record<string, string>
}

const value = computed(() => {
  if (!Array.isArray(props.data) || props.data.length === 0) return []
  return props.data as TagItem[]
})
</script>

<template>
  <div class="table-cell flex gap-1">
    <Tag
      v-for="(item, idx) in value"
      :key="`badge-${idx}`"
      class="!font-[300] !text-[11px] whitespace-nowrap"
      :class="item.class"
      :style="item.style as any"
      :value="item.label"
      :severity="item.type"
    />
  </div>
</template>

<style scoped></style>
